var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { padding: "10px", color: "#d9d9d9" } }, [
        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OcrTip")))
      ]),
      _c("div", { staticClass: "result-form-se-new" }, [
        _c("div", { staticClass: "two-column-layout" }, [
          _c("div", { staticClass: "recognition-results-column" }, [
            _c("div", { staticClass: "column-header" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BillResults")))])
            ]),
            _c("div", { staticClass: "column-content" }, [
              _vm.currentOcrRecognitionFields &&
              _vm.currentOcrRecognitionFields.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.currentOcrRecognitionFields, function(item) {
                      return _c("div", { key: item.code }, [
                        _c("div", { staticStyle: { display: "none" } }, [
                          _vm._v(_vm._s(_vm.getValueBorderColor(item)))
                        ]),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_BILL_NO.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm.source ===
                                      _vm.INTELLIGENT_DOCUMENT_SOURCE_5.code ||
                                    _vm.source ===
                                      _vm.INTELLIGENT_DOCUMENT_SOURCE_6.code
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_BLNo")
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    [
                                      _vm.INTELLIGENT_DOCUMENT_SOURCE_7.code,
                                      _vm.INTELLIGENT_DOCUMENT_SOURCE_16.code,
                                      _vm.INTELLIGENT_DOCUMENT_SOURCE_8.code
                                    ].includes(_vm.source)
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_SeparateNumber"
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_ORDER_TYPE.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.BLForm")))]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_BL_NUMBER.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_NumberOfOriginalCopies"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_SHIPPER.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block recognition-field field-block-textarea",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Message.Shipper")))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                ),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_CONSIGNEE.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block recognition-field field-block-textarea",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Message.Consignee")))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                ),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_NOTIFY.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block recognition-field field-block-textarea",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Message.Notify")))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                ),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_CARRIER.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ShippingCompany")
                                      )
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_VESSEL.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Payment.vessel")))]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_VOYAGE.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Payment.voyage")))]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_PAYMENT_TERM.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.FreightTerm"))
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_FREIGHT_TERM.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.TransportationClause")
                                      )
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_CONTAINER_INFOS.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block recognition-field field-block-container-eq",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "block" } },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_CartonQuantity"
                                              )
                                            )
                                          )
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              color: "#cbc7c7",
                                              "font-size": "12px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                "(" +
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_NotUpdate"
                                                  ) +
                                                  ")"
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value container-eq-left-value"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.resultJson[item.code]) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_LOADING_PORT.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.PortOfLoadingOnBl")
                                      )
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_DISCHARGING_PORT.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.PortOfDischargeOnBl")
                                      )
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_DESTINATION_PORT.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.PlaceOfDeliveryOnBl")
                                      )
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_TD_QUANTITY.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_PACKING.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Package")))]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_TD_WEIGHT.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Weight")))]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_TD_CUBAGE.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_MARK.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block recognition-field field-block-textarea",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Marks")))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                ),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_GOOD_NAME.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block recognition-field field-block-textarea",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Pricing.Goods")))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                ),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_REMARKS.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block recognition-field field-block-textarea",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Payment.remarks")))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                ),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_PAYMENT_PLACE_BL.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.PlaceOfPayment"))
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_TD_SIGN_PLACE_BL.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.PlaceOfIssue"))
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_TD_SIGN_DATE_BL.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.DateOfIssue"))
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_HS_CODE.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block recognition-field field-block-textarea",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.HsCode")))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [_vm._v(_vm._s(_vm.resultJson[item.code]))]
                                ),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_DISPATCHING_PLACE.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.PlaceOfReceiptOnBl")
                                      )
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_INSIDE_QUANTITY.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Pieces2")))]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_INSIDE_PACKING.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "field-block recognition-field",
                                class: { "field-red-border": item.redColor },
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.PiecesType2"))
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "field-value" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ]),
                                _c("div", { staticClass: "field-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn accept-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.itemAssignClick(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✓")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.redColor && !item.hideActions,
                                          expression:
                                            "item.redColor && !item.hideActions"
                                        }
                                      ],
                                      staticClass: "action-btn reject-btn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.rejectField(item)
                                        }
                                      }
                                    },
                                    [_vm._v("✗")]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ])
          ]),
          _c("div", { staticClass: "system-data-column" }, [
            _c("div", { staticClass: "column-header" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BillResults2")))
              ])
            ]),
            _c("div", { staticClass: "column-content" }, [
              _vm.currentOcrRecognitionFields &&
              _vm.currentOcrRecognitionFields.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.currentOcrRecognitionFields, function(item) {
                      return _c("div", { key: "system-" + item.code }, [
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_BILL_NO.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm.source ===
                                      _vm.INTELLIGENT_DOCUMENT_SOURCE_5.code ||
                                    _vm.source ===
                                      _vm.INTELLIGENT_DOCUMENT_SOURCE_6.code
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_BLNo")
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    [
                                      _vm.INTELLIGENT_DOCUMENT_SOURCE_7.code,
                                      _vm.INTELLIGENT_DOCUMENT_SOURCE_16.code,
                                      _vm.INTELLIGENT_DOCUMENT_SOURCE_8.code
                                    ].includes(_vm.source)
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_SeparateNumber"
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.billNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "billNo", $$v)
                                        },
                                        expression: "doc.billNo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_ORDER_TYPE.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.BLForm")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "",
                                          disabled: _vm.fieldEditCheck(
                                            item.code
                                          ),
                                          no: "orderType",
                                          clearable: ""
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          }
                                        },
                                        model: {
                                          value: _vm.doc.orderType,
                                          callback: function($$v) {
                                            _vm.$set(_vm.doc, "orderType", $$v)
                                          },
                                          expression: "doc.orderType"
                                        }
                                      },
                                      _vm._l(_vm.blModeList, function(
                                        blItem,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: blItem.name,
                                            value: blItem.serialNumber
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_BL_NUMBER.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_NumberOfOriginalCopies"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.blNumber,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "blNumber", $$v)
                                        },
                                        expression: "doc.blNumber"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_SHIPPER.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block system-field field-block-textarea"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Message.Shipper")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.shipper,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "shipper", $$v)
                                        },
                                        expression: "doc.shipper"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_CONSIGNEE.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block system-field field-block-textarea"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Message.Consignee")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.consignee,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "consignee", $$v)
                                        },
                                        expression: "doc.consignee"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_NOTIFY.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block system-field field-block-textarea"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Message.Notify")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.notify,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "notify", $$v)
                                        },
                                        expression: "doc.notify"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_CARRIER.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ShippingCompany")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-company-select", {
                                      attrs: {
                                        "method-params": {
                                          companyLob: "seaExport",
                                          seaCmp: true,
                                          active: true
                                        },
                                        "default-value":
                                          _vm.doc.carrierId || "",
                                        placeholder: "",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        change: function(p) {
                                          _vm.pm.carrierChangeHandler(
                                            _vm.doc.dischargingPortCode,
                                            p.value
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_VESSEL.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Payment.vessel")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .static_data_Vessel,
                                        cache: false,
                                        filterable: "",
                                        "allow-create": true,
                                        "default-value": _vm.doc.vessel,
                                        "static-options": _vm.vesselList,
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.onVesselSelectionChange(p)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_VOYAGE.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Payment.voyage")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.voyageFlight,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "voyageFlight", $$v)
                                        },
                                        expression: "doc.voyageFlight"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_PAYMENT_TERM.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.FreightTerm"))
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_PaymentTerm,
                                        filterable: "",
                                        clearable: "",
                                        "default-value": _vm.doc.paymentTermMBL,
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        parentCallBack: function(p) {
                                          _vm.paymentTermMBL = p.value
                                          _vm.doc.paymentTermMBL = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_FREIGHT_TERM.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_TransitTerm")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_ShippingTerm,
                                        filterable: "",
                                        disabled: _vm.fieldEditCheck(item.code),
                                        clearable: false,
                                        "default-value":
                                          _vm.doc.freightTerm || ""
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        parentCallBack: function(p) {
                                          _vm.doc.freightTerm = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_CONTAINER_INFOS.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block system-field field-block-container-eq"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "block" } },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_CartonQuantity"
                                              )
                                            )
                                          )
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              color: "#cbc7c7",
                                              "font-size": "12px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                "(" +
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_NotUpdate"
                                                  ) +
                                                  ")"
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value container-eq-right-value"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "flex-direction": "column",
                                              "max-height": "180px"
                                            }
                                          },
                                          _vm._l(_vm.doc.seaEQ, function(
                                            eqItem,
                                            index
                                          ) {
                                            return _c("div", { key: index }, [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "center",
                                                    "margin-bottom": "8px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        width: "49%",
                                                        display: "flex",
                                                        "align-items": "center"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input-number", {
                                                        staticStyle: {
                                                          width: "60px"
                                                        },
                                                        attrs: {
                                                          disabled: true,
                                                          controls: false
                                                        },
                                                        model: {
                                                          value:
                                                            eqItem.eqQuantity,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              eqItem,
                                                              "eqQuantity",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "eqItem.eqQuantity"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "8px",
                                                            "margin-right":
                                                              "8px"
                                                          }
                                                        },
                                                        [_vm._v("X")]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "align-items": "center"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "cargo-advance-select",
                                                        {
                                                          staticStyle: {
                                                            width: "60px",
                                                            "margin-right":
                                                              "4px"
                                                          },
                                                          attrs: {
                                                            no: "eqSize",
                                                            "select-type":
                                                              _vm
                                                                .selectTypeNames
                                                                .local_cache_EQSize,
                                                            fields: ["code"],
                                                            filterable: "",
                                                            placeholder: " ",
                                                            "show-copy": false,
                                                            disabled: true,
                                                            "default-value":
                                                              eqItem.eqSize,
                                                            "tag-name": "code"
                                                          },
                                                          on: {
                                                            parentCallBack: function(
                                                              p
                                                            ) {
                                                              _vm.changeSizeCallBack(
                                                                eqItem,
                                                                p
                                                              )
                                                            }
                                                          }
                                                        }
                                                      ),
                                                      _c(
                                                        "cargo-advance-select",
                                                        {
                                                          staticStyle: {
                                                            width: "60px"
                                                          },
                                                          attrs: {
                                                            no: "eqType",
                                                            "select-type":
                                                              _vm
                                                                .selectTypeNames
                                                                .basic_data_EQType,
                                                            fields: ["code"],
                                                            filterable: "",
                                                            placeholder: " ",
                                                            "show-copy": false,
                                                            disabled: true,
                                                            "default-value":
                                                              eqItem.eqType,
                                                            "tag-name": "code"
                                                          },
                                                          on: {
                                                            parentCallBack: function(
                                                              p
                                                            ) {
                                                              _vm.changeTypeCallBack(
                                                                eqItem,
                                                                p
                                                              )
                                                            }
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ])
                                          }),
                                          0
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_LOADING_PORT.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.PortOfLoadingOnBl")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.loadingPort,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "loadingPort", $$v)
                                        },
                                        expression: "doc.loadingPort"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_DISCHARGING_PORT.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.PortOfDischargeOnBl")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.dischargingPort,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.doc,
                                            "dischargingPort",
                                            $$v
                                          )
                                        },
                                        expression: "doc.dischargingPort"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_DESTINATION_PORT.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.PlaceOfDeliveryOnBl")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.destinationPort,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.doc,
                                            "destinationPort",
                                            $$v
                                          )
                                        },
                                        expression: "doc.destinationPort"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_TD_QUANTITY.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        controls: false,
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.quantity,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "quantity", $$v)
                                        },
                                        expression: "doc.quantity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_PACKING.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Package")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-packing-select", {
                                      attrs: {
                                        "default-value": _vm.doc.packing || "",
                                        placeholder: "",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        change: function(v) {
                                          return (_vm.doc.packing = v.value)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_TD_WEIGHT.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Weight")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        controls: false,
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.weight,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "weight", $$v)
                                        },
                                        expression: "doc.weight"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_TD_CUBAGE.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        controls: false,
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.cubage,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "cubage", $$v)
                                        },
                                        expression: "doc.cubage"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_MARK.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block system-field field-block-textarea"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Marks")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.mark,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "mark", $$v)
                                        },
                                        expression: "doc.mark"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_GOOD_NAME.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block system-field field-block-textarea"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Pricing.Goods")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.cargoEnglishName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.doc,
                                            "cargoEnglishName",
                                            $$v
                                          )
                                        },
                                        expression: "doc.cargoEnglishName"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_REMARKS.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block system-field field-block-textarea"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Payment.remarks")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.remarks,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "remarks", $$v)
                                        },
                                        expression: "doc.remarks"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_PAYMENT_PLACE_BL.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.PlaceOfPayment"))
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.paymentPlaceBL,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.doc,
                                            "paymentPlaceBL",
                                            $$v
                                          )
                                        },
                                        expression: "doc.paymentPlaceBL"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_TD_SIGN_PLACE_BL.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.PlaceOfIssue"))
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.signPlaceBL,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "signPlaceBL", $$v)
                                        },
                                        expression: "doc.signPlaceBL"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_TD_SIGN_DATE_BL.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.DateOfIssue"))
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        value: _vm.doc.signDateBL,
                                        type: "date",
                                        "value-format": "yyyy-MM-dd",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      on: { input: _vm.signDateBLChange }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_HS_CODE.code
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "field-block system-field field-block-textarea"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.HsCode")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.hsCode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.doc, "hsCode", $$v)
                                        },
                                        expression: "doc.hsCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_DISPATCHING_PLACE.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.PlaceOfReceiptOnBl")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.dispatchingPlace,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.doc,
                                            "dispatchingPlace",
                                            $$v
                                          )
                                        },
                                        expression: "doc.dispatchingPlace"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_INSIDE_QUANTITY.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Pieces2")))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        controls: false,
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      model: {
                                        value: _vm.doc.insideQuantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.doc,
                                            "insideQuantity",
                                            $$v
                                          )
                                        },
                                        expression: "doc.insideQuantity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.showFieldItem(
                          item,
                          _vm.SystemConstants.OCR_FIELD_INSIDE_PACKING.code
                        )
                          ? _c(
                              "div",
                              { staticClass: "field-block system-field" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.PiecesType2"))
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-packing-select", {
                                      attrs: {
                                        "default-value":
                                          _vm.doc.insidePacking || "",
                                        placeholder: "",
                                        disabled: _vm.fieldEditCheck(item.code)
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        change: function(v) {
                                          return (_vm.doc.insidePacking =
                                            v.value)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ])
          ])
        ]),
        _vm.currentOcrRecognitionFields &&
        _vm.currentOcrRecognitionFields.some(function(item) {
          return item.code === _vm.SystemConstants.OCR_FIELD_CONTAINER_DATA.code
        })
          ? _c("div", { staticClass: "container-data-section" }, [
              _c(
                "div",
                {
                  staticClass: "container-data-block",
                  on: {
                    click: function($event) {
                      return _vm.handleFocus(
                        _vm.SystemConstants.OCR_FIELD_CONTAINER_DATA.code
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "container-info-wrapper" }, [
                    _c("span", { staticClass: "container-tip-icon" }, [
                      _vm._v(_vm._s("."))
                    ]),
                    _c("div", { staticClass: "container-tip-text" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ContainerIdTip")))
                    ]),
                    _c("table", { staticClass: "container-table" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          {
                            staticClass: "gray-row",
                            staticStyle: { height: "30px" }
                          },
                          [
                            _c("td", { staticClass: "centered-cell" }),
                            _c("td", { staticClass: "centered-cell" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.ChargeSource")))
                            ]),
                            _c("td", { staticClass: "centered-cell" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.ContainerNo")))
                            ]),
                            _c("td", { staticClass: "centered-cell" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.BoxType")))
                            ]),
                            _c("td", { staticClass: "centered-cell" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.SealNo")))
                            ]),
                            _c("td", { staticClass: "centered-cell" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.itemCount")))
                            ]),
                            _c("td", { staticClass: "centered-cell" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Package")))
                            ]),
                            _c("td", { staticClass: "centered-cell" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Weight2")))
                            ]),
                            _c("td", { staticClass: "centered-cell" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))
                            ])
                          ]
                        )
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.doc.container, function(
                          containerItem,
                          index
                        ) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: containerItem.showCheck > 0,
                                    expression: "containerItem.showCheck > 0"
                                  }
                                ],
                                staticClass: "centered-cell",
                                staticStyle: { width: "5%" },
                                attrs: {
                                  rowspan: Number(containerItem.showCheck)
                                }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: containerItem.checked,
                                      expression: "containerItem.checked"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      containerItem.checked
                                    )
                                      ? _vm._i(containerItem.checked, null) > -1
                                      : containerItem.checked
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = containerItem.checked,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              containerItem,
                                              "checked",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              containerItem,
                                              "checked",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(containerItem, "checked", $$c)
                                      }
                                    }
                                  }
                                })
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "centered-cell",
                                staticStyle: { width: "10%" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    containerItem.chargeSource
                                      ? _vm.$t("CargoMsg.Cargo_RecognitionData")
                                      : _vm.$t("CargoMsg.Cargo_SystemData")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "centered-cell",
                                staticStyle: { width: "15%" }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.fieldEditCheck(
                                      "container_containerNo"
                                    ),
                                    no: "containerNo"
                                  },
                                  on: { change: _vm.containerNoChargeHandler },
                                  model: {
                                    value: containerItem.containerNo,
                                    callback: function($$v) {
                                      _vm.$set(
                                        containerItem,
                                        "containerNo",
                                        $$v
                                      )
                                    },
                                    expression: "containerItem.containerNo"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "centered-cell",
                                staticStyle: { width: "10%" }
                              },
                              [_vm._v(_vm._s(containerItem.eqSizeStr))]
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "centered-cell",
                                staticStyle: { width: "15%" }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.fieldEditCheck(
                                      "container_sealNo"
                                    ),
                                    no: "sealNo"
                                  },
                                  model: {
                                    value: containerItem.sealNo,
                                    callback: function($$v) {
                                      _vm.$set(containerItem, "sealNo", $$v)
                                    },
                                    expression: "containerItem.sealNo"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "centered-cell",
                                staticStyle: { width: "10%" }
                              },
                              [
                                _c("auto-number-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "quantity",
                                    disabled: _vm.fieldEditCheck(
                                      "container_quantity"
                                    ),
                                    precision: 0,
                                    min: 0
                                  },
                                  model: {
                                    value: containerItem.quantity,
                                    callback: function($$v) {
                                      _vm.$set(containerItem, "quantity", $$v)
                                    },
                                    expression: "containerItem.quantity"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "centered-cell",
                                staticStyle: { width: "15%" }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "packing",
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Packing,
                                    filterable: "",
                                    disabled: _vm.fieldEditCheck(
                                      "container_packing"
                                    ),
                                    "default-value": containerItem.packing
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      containerItem.packing = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "centered-cell",
                                staticStyle: { width: "10%" }
                              },
                              [
                                _c("auto-number-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "weight",
                                    disabled: _vm.fieldEditCheck(
                                      "container_weight"
                                    ),
                                    precision: 3,
                                    min: 0
                                  },
                                  model: {
                                    value: containerItem.weight,
                                    callback: function($$v) {
                                      _vm.$set(containerItem, "weight", $$v)
                                    },
                                    expression: "containerItem.weight"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "centered-cell",
                                staticStyle: { width: "10%" }
                              },
                              [
                                _c("auto-number-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "cubage",
                                    disabled: _vm.fieldEditCheck(
                                      "container_cubage"
                                    ),
                                    precision: 3,
                                    min: 0
                                  },
                                  model: {
                                    value: containerItem.cubage,
                                    callback: function($$v) {
                                      _vm.$set(containerItem, "cubage", $$v)
                                    },
                                    expression: "containerItem.cubage"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        }),
                        0
                      )
                    ]),
                    _c("div", { staticStyle: { "padding-top": "10px" } })
                  ])
                ]
              )
            ])
          : _vm._e()
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            no: "fieldValidDialog",
            visible: _vm.fieldValidDialog.visible,
            title: _vm.$t("Message.WarmReminder"),
            width: "630px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.fieldValidDialog, "visible", $event)
            }
          }
        },
        [
          _vm._l(_vm.fieldValidDialog.fieldValidResults, function(
            fieldValidResultByBook,
            index
          ) {
            return _c(
              "div",
              { key: index },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_Book") +
                        (fieldValidResultByBook.index + 1)
                    )
                  )
                ]),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: fieldValidResultByBook.data }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "fieldName",
                        label: _vm.$t("CargoMsg.Cargo_FieldName"),
                        width: "180"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "exceptionReason",
                        label: _vm.$t("CargoMsg.Cargo_ErrorCause"),
                        width: "400"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          }),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.fieldValidDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }